// ----------------------------------------------------------------------
// <copyright file="Izenda.FontFormat.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Font Format component
 */
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var DropDown = require('./Izenda.DropDown');
  var constants = require('logic/data/Izenda.UIConstants');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  const { clone, values } = require('lodash/fp');

  var FontFormat = React.createClass({
    propTypes: {
      value: React.PropTypes.object,
      onChange: React.PropTypes.func.isRequired,
      disabled: React.PropTypes.bool,
      isFontSizeHidden: React.PropTypes.bool
    },

    getDefaultProps: function() {
      return {
        value: {
          fontFamily: constants.fontFamily.proxima,
          fontSize: constants.fontSize[0]
        },
        blankOption: false,
        disabled: false
      };
    },

    handleChangeFontSize: function(e) {
      var props = this.props;
      var fontFormat = clone(props.value);

      fontFormat.fontSize = parseInt(e.value, 10) || '';
      props.onChange && props.onChange({ value: fontFormat }, { keyChange: 'fontSize' });
    },

    handleChangeFontFamily: function(e) {
      var props = this.props;
      var fontFormat = clone(props.value);

      fontFormat.fontFamily = e.value;
      props.onChange && props.onChange({ value: fontFormat }, { keyChange: 'fontFamily' });
    },

    render: function() {
      var props = this.props;
      var disabled = props.disabled;
      var fontFormat = this.props.value || {};
      var listFontFamily = values(constants.fontFamily);
      var fontSize = (fontFormat.fontSize!=null)? parseInt(fontFormat.fontSize):constants.fontSize[5];
      
      let fontFamily=(fontFormat.fontFamily!==null)?fontFormat.fontFamily:listFontFamily[0];

      return (
        <GridLayout>
          <GridLayout.FullRow>
            <GridLayout.Col cols={props.isFontSizeHidden ? 12 : 7} className='u_noPaddingRight'>
              <DropDown
                className='font-family'
                valueField=''
                labelField=''
                options={listFontFamily}
                value={fontFamily}
                disabled={disabled}
                onChange={this.handleChangeFontFamily}
                blankOption={props.blankOption}
              />
            </GridLayout.Col>
            {
              !props.isFontSizeHidden &&
              <GridLayout.Col cols={5} className='u_noPaddingLeft'>
                <DropDown
                  className='font-size'
                  valueField=''
                  labelField=''
                  options={constants.fontSize}
                  value={fontSize}
                  disabled={disabled}
                  onChange={this.handleChangeFontSize}
                  blankOption={props.blankOption}
                />
              </GridLayout.Col>
            }
          </GridLayout.FullRow>
        </GridLayout>
      );
    }
  });

  module.exports = observer(FontFormat);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.FontFormat.jsx